import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import EventPage from "@/pages/EventPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminPage from "@/pages/AdminPage";
import ReviewPage from "@/pages/ReviewPage";

function App() {
  useEffect(() => {
    document.title = "Beer Explained · The Horseshoe, Chipping Sodbury";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#121d15",
              border: "1px solid rgba(201,162,74,0.5)",
              color: "#ece4cf",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<EventPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/review" element={<ReviewPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
